import { render } from "./LocChuyenDi.vue?vue&type=template&id=48c6436a&scoped=true"
import script from "./LocChuyenDi.vue?vue&type=script&lang=js"
export * from "./LocChuyenDi.vue?vue&type=script&lang=js"

import "./LocChuyenDi.vue?vue&type=style&index=0&id=48c6436a&lang=scss&scoped=true"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\banvetaimaypos_fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c6436a"]])

export default __exports__